import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { v4 as uuidv4 } from 'uuid'
import { addNotification, showNotification } from '../../../api/redux/notificationAction'
import projectDataFlows from '../../../data.json'
import { fetchProcessFlowForFlow, getMergedFlows } from '../../../utils/flowUtils'
import { getCurrentContextuserIdDetails, isJson } from '../Admin/AccountUtility'
import MainErrorBoundaryParent from '../utils/ErrorBoundary/MainErrorBoundaryParent'
import { sUserCredentials } from '../utils/commonUtilityFunctions'
import { jwtDecode } from 'jwt-decode'
import './index.css'
import Overlay from './overlay'
import Start from './Start'
import { isObjectEqual, getPaymentProductId } from '../../../UI-components/ProjectTemplate/projectHelpers'
import CreateProjectPanel from '../../../UI-components/ProjectTemplate/CreateProjectPanel'
import { countries, isUserCountryValid } from '../utils/commonUtilityFunctions'

class Welcome extends React.Component {
  constructor() {
    super()

    this.state = {
      sampleProjects: [],
      selected: null,
      formDialogue: false,
      groupLoading: false,
      status: null,
      projectLoading: false,
      overlay: false,
      showWelcome: false,
      welcomeOverlay: false,
      instance: null,
      orgId: null,
      instanceState: null,
      showButtons: null,
      selectedSampleLabel: null,
      orgIdName: null,
      orgCreated: false,
      error: null,
      projectCreation: null,
      process_flow: null,
      projectID: null,
      errorMain: false,
      project_flow: null,
      loadingSamples: true,
      project_error: false,
      sampleProjectJson: [],
      floWprojects: null,
      floWprojectsLoad: null,
      flowGroups: {},
      isLoadingUPlan: false,
      uPCreation: false,
      projectCreated: [],
      pageRecords: { start: 0, max: 1000 },
      wGroupCreated: [],
      isAddedDone: false,
      showBuyCourse: false,
      showBuyGroupInfo: null,
      projectCreationError: null,
      showCountryCodeSelector: false,
      showPlanSelector: false,
      selectedCountryCode: null,
      selectedPlan: null,
      countryCodeError: '',
      planError: '',
      pendingOrgCreationPayload: null
    }
    this.createP = this.createP.bind(this)
    this.aPTGroup = this.aPTGroup.bind(this)
    this.iUTProject = this.iUTProject.bind(this)
  }

  checkIsAddIntrestedAddons = (payload, silent) => {
    if (this.props.api && this.props.api.keycloakToken()) {
      let jwt_token_object = {}

      try {
        const decoded = jwtDecode(this.props.api.keycloakToken())
        jwt_token_object = decoded
      } catch (error) { console.error('Error while decoding the jwt token at dashboard.js', error) }
      if (jwt_token_object && jwt_token_object.may_buy_addon_prodid) {
        const addOnProducts =
          this.props.isSubscriptionCheck &&
            !this.props.isSubscriptionCheck.isLoading &&
            this.props.isSubscriptionCheck.addOnProducts
            ? this.props.isSubscriptionCheck.addOnProducts
            : []
        if (addOnProducts && addOnProducts.length > 0 && !addOnProducts.includes(jwt_token_object.may_buy_addon_prodid)) {
          const groupToBuy = Object.entries(payload).find(([key, item]) => getPaymentProductId(item) === jwt_token_object.may_buy_addon_prodid)
          const flattenObject = groupToBuy
            ? { ...groupToBuy[1], key: groupToBuy[0] }
            : null;
          this.setState({ showBuyCourse: true, showBuyGroupInfo: flattenObject })
          if (flattenObject && flattenObject.key && (silent === undefined || silent === false))
            this.navigateTo(`/projects/flows/learn/${flattenObject['key']}`)
        }
      }
    }
  }

  componentDidMount() {
    const isProject = this.props.projectComponent
    this.setState({
      welcomeOverlay: isProject !== undefined ? false : true,
      showWelcome: isProject !== undefined ? true : false,
      projectCreation: isProject === undefined ? false : true
    })
    this.fetchAllFlows()
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    if (current_logged_user.orgId) {
      if (isProject) {
        this.refreshGroups(true)
      }
    }
    this.setState({ instanceState: 'first' })
    const countryInfo = isUserCountryValid()
    const defaultCountryCode = countryInfo && countryInfo.country ? countryInfo.country : 'IN'
    const selectedCountryCode =
      countries.find(country => country.value === defaultCountryCode) ||
      countries.find(country => country.value === 'IN') ||
      null
    this.setState({ selectedCountryCode: selectedCountryCode })
    if (this.props.projectComponent === undefined) {
      this.fetchUserOrganziationInfo()
    }
  }

  isFetched = (slice) => {
    return !!(slice && slice.fetched && slice.fetched === true);
  }

  getFlows = (slice) => {
    return slice && Array.isArray(slice.flows) ? slice.flows : [];
  }

  ensurePracticeFlowsAndMerge() {
    // Dashboard.js handles all flow fetching (global + org).
    // Just read merged flows from Redux props.
    var mergedFlows = getMergedFlows({
      learnPracticeFlows: this.props.learnPracticeFlows,
      buildPracticeFlows: this.props.buildPracticeFlows
    });
    return mergedFlows.filter(function (obj) { return isObjectEqual(obj); });
  }

  fetchAllFlows = () => {
    const practiceFlows = this.ensurePracticeFlowsAndMerge();
    this.setState({ sampleProjectJson: practiceFlows.length === 0 ? projectDataFlows : practiceFlows })
  }

  refreshGroups = (silent) => {
    if (!silent) {
      this.setState({ groupLoading: true })
    }
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const { api } = this.props
    if (api == null) return
    const action = api.createListGroupsRSAA(current_logged_user, { start: 0, max: -1 }, null)
    Promise.resolve(this.props.dispatch(action)).then(response => {
      if (!silent) {
        this.setState({ groupLoading: false })
      }
    })
  }

  buyCourse = (planId, successUrl, cancelUrl) => {
    this.setState({ isLoadingUPlan: true })
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const bodyparams = {
      successUrl: successUrl ? successUrl : `${window.REACT_APP_SELF_URL}/organizations/billings?paymentSuccess=78dfr030`,
      cancelUrl: cancelUrl ? cancelUrl : `${window.REACT_APP_SELF_URL}/organizations/billings?paymentFail=s67830-09`,
      productId: planId,
      productQuantity: 1,
      paymentMode: `payment`
    }

    const { api } = this.props
    if (api == null) return
    Promise.resolve(this.props.dispatch(api.createCheckOutSessionRSAA(current_logged_user, bodyparams)))
      .then(response => {
        const t = response.type.toLowerCase()
        const hasError = t.endsWith('failure')
        if (!hasError) {
          window.location = response.payload.stripe && response.payload.stripe.url ? response.payload.stripe.url : '/'
        } else {
          this.props.dispatch(
            addNotification(
              `${response.payload && response.payload.response && response.payload.response.message
                ? response.payload.response.message
                : window.REACT_APP_ERROR_MESSAGE
              }`,
              'danger',
              false
            )
          )
          this.props.dispatch(showNotification(true))
        }
      })
      .then(() => {
        this.setState({ isLoadingUPlan: false })
      })
  }

  componentDidUpdate(prevProps) {
    // Trigger checkIsAddIntrestedAddons when masterGroupMapper updates from Redux
    if (
      this.props.masterGroupMapper !== prevProps.masterGroupMapper &&
      !this.props.masterGroupMapper.isLoading &&
      this.props.masterGroupMapper.groups &&
      typeof this.props.masterGroupMapper.groups === 'object' &&
      !Array.isArray(this.props.masterGroupMapper.groups)
    ) {
      const currentPlan =
        (this.props.isSubscriptionCheck &&
          !this.props.isSubscriptionCheck.isLoading &&
          this.props.isSubscriptionCheck.subscribedProduct &&
          this.props.isSubscriptionCheck.subscribedProduct.name
          ? this.props.isSubscriptionCheck.subscribedProduct.name
          : 'NO_PLAN').toUpperCase()

      if (currentPlan === 'LEARNER')
        this.checkIsAddIntrestedAddons(this.props.masterGroupMapper.groups, false)
    }

    // Re-process flows when learn or build practice flows update (e.g. org-specific flows arrive)
    if (
      this.props.learnPracticeFlows !== prevProps.learnPracticeFlows ||
      this.props.buildPracticeFlows !== prevProps.buildPracticeFlows
    ) {
      const mergedFlows = getMergedFlows({
        learnPracticeFlows: this.props.learnPracticeFlows,
        buildPracticeFlows: this.props.buildPracticeFlows
      });
      if (mergedFlows.length > 0) {
        const filtered = mergedFlows.filter(obj => isObjectEqual(obj));
        this.setState({ sampleProjectJson: filtered.length > 0 ? filtered : projectDataFlows });
      }
    }
  }

  //3rd call to create organization
  organizationCreation = bodyparams => {
    const { api } = this.props
    if (api == null) return
    this.setState({ pendingOrgCreationPayload: bodyparams })
    Promise.resolve(this.props.dispatch(api.createUserOrganizationRSAA(bodyparams))).then(response => {
      const t = response.type.toLowerCase()
      const hasError = t.endsWith('failure')
      if (!hasError) {
        this.setState({ showCountryCodeSelector: false, countryCodeError: '', error: null })
        if (
          response.payload &&
          response.payload.subscriptionStatus &&
          response.payload.subscriptionStatus === 'BUY_PLAN'
        ) {
          this.checkoutSession(bodyparams, response.payload.organization.id)
        } else {
          window.location.reload('/')
        }
      } else {
        const errorMessage =
          (response && response.payload && response.payload.response && response.payload.response.message) ||
          (response && response.payload && response.payload.message) ||
          (response && response.payload && response.payload.response && response.payload.response.error) ||
          (response && response.payload && response.payload.error) ||
          window.REACT_APP_ERROR_MESSAGE
        this.props.dispatch(addNotification(errorMessage, 'danger', false))
        this.props.dispatch(showNotification(true))
        if (this.state.projectCreation === false) {
          const msgLower = (errorMessage || '').toLowerCase()
          const needsCountry = msgLower.includes('country')
          const needsPlan = msgLower.includes('product') || msgLower.includes('plan') || msgLower.includes('prodid') || msgLower.includes('planid')
          this.setState({
            error: errorMessage,
            showCountryCodeSelector: needsCountry,
            showPlanSelector: needsPlan && !needsCountry
          })
        }
      }
    })
  }

  handleCountryCodeChange = selectedCountryCode => {
    this.setState({ selectedCountryCode, countryCodeError: '' })
  }

  handlePlanChange = selectedPlan => {
    this.setState({ selectedPlan, planError: '' })
  }

  resolveOrgCreation = () => {
    if (this.state.showCountryCodeSelector) {
      const { selectedCountryCode, pendingOrgCreationPayload } = this.state
      if (!selectedCountryCode || !selectedCountryCode.value) {
        this.setState({ countryCodeError: 'Country code is required' })
        return
      }
      const retryPayload = {
        ...(pendingOrgCreationPayload || {}),
        countryCode: selectedCountryCode.value
      }
      this.setState({ error: null, countryCodeError: '' })
      this.organizationCreation(retryPayload)
      return
    }

    if (this.state.showPlanSelector) {
      const { selectedPlan, pendingOrgCreationPayload } = this.state
      if (!selectedPlan || !selectedPlan.value) {
        this.setState({ planError: 'Please select a plan' })
        return
      }
      const retryPayload = {
        ...(pendingOrgCreationPayload || {}),
        planId: selectedPlan.value
      }
      this.setState({ error: null, planError: '' })
      this.organizationCreation(retryPayload)
      return
    }

    this.setState({ error: null })
    this.fetchUserOrganziationInfo()
  }

  checkoutSession = (params, orgId) => {
    let current_logged_user = { orgId: orgId }
    const bodyparams = {
      successUrl: `${window.REACT_APP_SELF_URL}/organizations/billings?paymentSuccess=78dfr030`,
      cancelUrl: `${window.REACT_APP_SELF_URL}/organizations/billings?paymentFail=s67830-09`,
      productId: params.planId,
      paymentMode: `subscription`
    }

    const { api } = this.props
    if (api == null) return
    Promise.resolve(this.props.dispatch(api.createCheckOutSessionRSAA(current_logged_user, bodyparams))).then(
      response => {
        const t = response.type.toLowerCase()
        const hasError = t.endsWith('failure')
        if (!hasError) {
          window.location = response.payload.stripe && response.payload.stripe.url ? response.payload.stripe.url : '/'
        } else {
          this.props.dispatch(
            addNotification(
              `${response.payload && response.payload.response && response.payload.response.message
                ? response.payload.response.message
                : 'We are unable to Process, Please try later'
              }`,
              'danger',
              false
            )
          )
          this.props.dispatch(showNotification(true))
          window.location.reload('/')
        }
      }
    )
  }

  navigateTo = path => {
    const { history } = this.props
    history.push(path)
  }

  handleChange = (id, label) => {
    let orgDetails = {}
    if (this.state.orgCreated) {
      orgDetails = { orgIdName: this.state.orgIdName, orgId: this.state.orgId }
    } else {
      orgDetails = {
        orgIdName: getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user).orgIdName,
        orgId: getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user).orgId
      }
    }

    const userId = this.props.myUserAccountInfo.current_logged_user
    const switchTo = {
      orgId: orgDetails.orgId,
      orgIdName: orgDetails.orgIdName,
      spaceId: id,
      spaceIdName: label
    }

    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    if (current_logged_user && current_logged_user.spaceId === id) {
      this.navigateTo(`/${current_logged_user.orgId}/${id}/projects/${id}`)
    } else {
      if (!window.localStorage.defaultProfileSetting) {
        console.log('No data found in localStorage for key: defaultProfileSetting')
        window.location.reload()
        return
      }
      sUserCredentials(window.localStorage.defaultProfileSetting, userId, switchTo, true)
      setTimeout(() => {
        window.location = `/${orgDetails.orgId}/${id}/projects/${id}`
      }, 20)
    }
  }

  getOrgId = () => {
    if (this.state.projectCreation) {
      const userId = this.props.myUserAccountInfo.current_logged_user
      let defaultProfileSetting = isJson(window.localStorage.defaultProfileSetting)
      let cacheObject = defaultProfileSetting[userId]
      return cacheObject['activeOrganization']
    } else {
      return this.state.orgId
    }
  }

  fetchUserOrganziationInfo = () => {
    const fetchurl = `${window.REACT_APP_GATEWAY_API_URL}/profile/userRoles/user`
    fetch(fetchurl, {
      method: 'GET',
      headers: Object.assign(
        { 'Content-Type': 'application/json' },
        { Authorization: `Bearer ${this.props.api.keycloakToken()}` }
      )
    })
      .then(response => {
        return response.json()
      })
      .then(response => {
        const tokenDetails = JSON.parse(atob(this.props.api.keycloakToken().split('.')[1]))
        if (response.rolesUser === undefined) {
          this.organizationCreation({
            title: tokenDetails.org_name,
            planId: tokenDetails.prodId,
            description: 'new_user_org_description',
            owner: this.props.myUserAccountInfo.current_logged_user,
            name: 'new_user_org_name'
          })
          this.setState({ instance: 1 })
        } else {
          const firstOrg = response.rolesUser.organizations[0]
          this.setState({ instance: 1 })
          this.setState({ instanceState: 'second' })
          this.setState({ orgCreated: true, orgId: firstOrg.id, orgIdName: firstOrg.name })
        }
      })
      .catch(err => {
        if (this.state.projectCreation === false) {
          this.setState({ error: 'Something went wrong' })
        }
      })
  }

  createNormalSpaceCreation = async (spaceInfo) => {
    this.setState({ formDialogue: true, projectCreationError: null })
    const orgId = this.getOrgId()
    this.setState({ projectLoading: true })
    let current_logged_user = this.props.myUserAccountInfo.current_logged_user

    // Lazy-load process_flow if not already loaded
    let processFlow = this.state.process_flow
    if (!processFlow || processFlow.length === 0) {
      const matchingFlow = this.state.sampleProjectJson.find(f => f.flow_id === spaceInfo['flowId']) || {}
      processFlow = await fetchProcessFlowForFlow(this.props.dispatch, spaceInfo['flowId'], matchingFlow.process_flow_url, { flowProcessFlows: this.props.flowProcessFlows })
      this.setState({ process_flow: processFlow })
    }

    // Extract email prefix from profile instead of generating UUID
    const emailPrefix = this.props.myProfile && this.props.myProfile.email
      ? this.props.myProfile.email.split('@')[0]
      : uuidv4().replace(/-/g, '').substring(0, 6).toUpperCase()

    const body = {
      title: `${spaceInfo['title']}(${emailPrefix})`,
      flowId: spaceInfo['flowId'],
      advancedMode: false,
      projectObjectives: JSON.parse(
        JSON.stringify(
          processFlow
            .map((i, id) => {
              return (id !== undefined && i.objective) ? { sequence: id, objective: i.objective } : null
            })
            .filter(item => item !== null)
        )
      ),
      description: spaceInfo['space_desc'],
      createdOn: new Date(),
      createdBy: current_logged_user
    }

    const { api } = this.props
    if (api == null) return
    Promise.resolve(this.props.dispatch(api.createProjectFlowRSAA(orgId, body))).then(response => {
      const t = response.type.toLowerCase()
      const hasError = t.endsWith('failure')
      if (!hasError) {
        if (response && response.payload && response.payload.space && response.payload.space.id) {
          this.handleChange(response.payload.space.id, response.payload.space.title || `${spaceInfo['title']}(${emailPrefix})`)
        } else {
          window.location = `/`
        }
      } else {
        this.setState({ projectCreationError: response })
        this.setState({ projectLoading: false, formDialogue: false })
      }
    })
  }

  createNewSpace = (spaceInfo) => {
    if (spaceInfo['showAdvanced'] === true && spaceInfo['groupId'] && spaceInfo['roleName']) {
      Promise.resolve(this.getGroupMembers(spaceInfo['groupId'])).then(response => {
        const t = response.type.toLowerCase()
        const hasError = t.endsWith('failure')
        if (!hasError) {
          this.createGroupTSBulkFlow(spaceInfo, response.payload.members)
        } else {
          this.props.dispatch(
            addNotification(
              `${response.payload && response.payload.response && response.payload.response.message
                ? response.payload.response.message
                : window.REACT_APP_ERROR_MESSAGE
              }`,
              'danger',
              false
            )
          )
          this.props.dispatch(showNotification(true))
        }
      })
    } else {
      this.createNormalSpaceCreation(spaceInfo)
    }
  }

  createGroupTSBulkFlow = (spaceInfo, members) => {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const groupName = `${spaceInfo['title']}_${spaceInfo['groupName']}`
    const groupdesc = `${spaceInfo['space_desc']}`

    const group_Data = {
      title: groupName,
      description: groupdesc,
      tags: ['PROJECTS'],
      orgId: current_logged_user.orgId,
      active: 'true'
    }

    const { api } = this.props
    if (api == null) return
    const that = this
    Promise.resolve(this.props.dispatch(api.createGroupRSAA(current_logged_user, group_Data))).then(response => {
      const t = response.type.toLowerCase()
      const hasError = t.endsWith('failure')
      if (!hasError) {
        if (response && response.payload && response.payload.group && response.payload.group.id) {
          this.setState({ uPCreation: true, formDialogue: true, wGroupCreated: response.payload.group })
          const spaceInf = { ...spaceInfo, groupId: response.payload.group.id }
          this.bulkFlow(spaceInf, members)
        } else {
        }
      } else {
        this.dispatchError(response)
        this.setState({ projectLoading: false })
      }
    })
  }

  getGroupMembers = groupId => {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const { api } = this.props
    if (api == null) return
    return this.props.dispatch(
      api.createGetGroupMembersRSAA(current_logged_user, groupId, 'user', this.state.pageRecords)
    )
  }

  refreshOrgProject = () => {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const { api } = this.props
    if (api == null) return
    return this.props.dispatch(api.getAllProjectsOfOrgRSAA(current_logged_user))
  }

  bulkFlow = async (spaceInfo, members) => {
    const orgId = this.getOrgId()
    const current_logged_user = this.props.myUserAccountInfo.current_logged_user
    const cUser = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)

    // Lazy-load process_flow if not already loaded
    let processFlow = this.state.process_flow
    if (!processFlow || processFlow.length === 0) {
      const matchingFlow = this.state.sampleProjectJson.find(f => f.flow_id === spaceInfo['flowId']) || {}
      processFlow = await fetchProcessFlowForFlow(this.props.dispatch, spaceInfo['flowId'], matchingFlow.process_flow_url, { flowProcessFlows: this.props.flowProcessFlows })
      this.setState({ process_flow: processFlow })
    }

    const body = {
      flowId: spaceInfo['flowId'],
      advancedMode: false,
      projectObjectives: JSON.parse(
        JSON.stringify(
          processFlow
            .map((i, id) => {
              return (id !== undefined && i.objective) ? { sequence: id, objective: i.objective } : null
            })
            .filter(item => item !== null)
        )
      ),
      description: spaceInfo['space_desc'],
      createdOn: new Date(),
      createdBy: current_logged_user
    }

    const promises = []
    if (members) {
      let membersAdded = []
      const that = this
      for (let i = 0; i < members.length; i++) {
        const it = members[i]
        const spaceName = `${i + 1}. ${spaceInfo['title']} ${it.name}`
        const displayName = `${i + 1}. ${it.name}`
        membersAdded.push({ status: 'LOAD', content: {}, title: displayName })
        this.setState({ projectCreated: membersAdded })
        try {
          promises.push(
            await new Promise(function (resolve, reject) {
              that.createP(
                cUser,
                it,
                spaceInfo['roleName'],
                orgId,
                { ...body, title: spaceName },
                spaceInfo['groupId'],
                displayName,
                resolve,
                reject,
                false
              )
            })
          )
        } catch (error) {
          promises.push(error)
        }
      }

      Promise.allSettled(promises)
        .then(it => {
          let membersAdded = []
          it.map(item => {
            if (item.value['status'] === 'fulfilled') {
              membersAdded.push({
                status: 'PASS',
                content: item.value.data,
                title: item.value['title'],
                step: item.value.step
              })
            } else {
              membersAdded.push({
                status: 'FAIL',
                content: item.value.data,
                title: item.value['title'],
                step: item.value.step
              })
            }
          })
          this.setState({ projectCreated: membersAdded, isAddedDone: true })
        })
        .then(it => {
          this.setState({ formDialogue: false })
          this.refreshOrgProject()
        })
    }
  }

  createP(cUser, it, roleName, orgId, body, groupId, displayName, resolve, reject, isShow) {
    const { api } = this.props
    if (api == null) return
    const that = this
    Promise.resolve(this.props.dispatch(api.createProjectFlowRSAA(orgId, body))).then(response => {
      const t = response.type.toLowerCase()
      const hasError = t.endsWith('failure')
      if (!hasError) {
        if (response && response.payload && response.payload.space && response.payload.space.id) {
          that.aPTGroup(
            cUser,
            it,
            roleName,
            groupId,
            response.payload.space.id,
            orgId,
            displayName,
            resolve,
            reject,
            false
          )
        } else {
          reject({
            status: 'rejected',
            title: displayName,
            step: 1,
            data: { cUser, it, roleName, orgId, body, groupId }
          })
        }
      } else {
        if (isShow) this.dispatchError(response)
        reject({ status: 'rejected', title: displayName, step: 1, data: { cUser, it, roleName, orgId, body, groupId } })
      }
    })
  }

  aPTGroup(cUser, it, roleName, groupId, projectId, orgId, displayName, resolve, reject, isShow) {
    const body = {
      entityIds: [projectId],
      type: 'project'
    }
    const { api } = this.props
    if (api == null) return
    Promise.resolve(this.props.dispatch(api.createAddGroupEntityRSAA(cUser, groupId, body))).then(response => {
      const t = response.type.toLowerCase()
      const hasError = t.endsWith('failure')
      if (!hasError) {
        this.iUTProject(it, roleName, projectId, orgId, displayName, resolve, reject, false)
      } else {
        if (isShow) this.dispatchError(response)
        reject({
          status: 'rejected',
          step: 2,
          title: displayName,
          data: { cUser, it, roleName, groupId, projectId, orgId }
        })
      }
    })
  }

  iUTProject(it, roleName, projectId, orgId, displayName, resolve, reject, isShow) {
    let updatedBody = {
      email: it.email.trim(),
      orgId: orgId,
      roleName: roleName,
      spaceId: projectId,
      permissions: []
    }

    const { api } = this.props
    if (api == null) return
    Promise.resolve(this.props.dispatch(api.createInviteUserToProjectRSAA(updatedBody, orgId, projectId))).then(
      response => {
        const t = response.type.toLowerCase()
        const hasError = t.endsWith('failure')
        if (!hasError) {
          resolve({ status: 'fulfilled', step: 1, title: displayName, data: { it, roleName, projectId, orgId } })
        } else {
          if (isShow) this.dispatchError(response)
          reject({ status: 'rejected', step: 3, title: displayName, data: { it, roleName, projectId, orgId } })
        }
      }
    )
  }

  dispatchError = response => {
    this.props.dispatch(
      addNotification(
        response && response.payload && response.payload.response && response.payload.response.message
          ? response.payload.response.message
          : window.REACT_APP_ERROR_MESSAGE,
        'error',
        false
      )
    )
    this.props.dispatch(showNotification(true))
  }

  getRouterFlowGroupId = props => {
    const _props = props != null ? props : this.props
    const {
      match: {
        params: { flowGroupId }
      }
    } = _props
    return flowGroupId || null
  }

  getRouterFlowTypeId = props => {
    const _props = props != null ? props : this.props
    const {
      match: {
        params: { flowType }
      }
    } = _props
    return flowType || null
  }

  updateProjectCreationError = () => {
    if (this.state.projectCreationError) {
      this.setState({
        projectCreationError: null
      })
    }
  }

  render() {
    const { sampleProjects, status, overlay, showWelcome, welcomeOverlay, instance, instanceState, showButtons } =
      this.state
    return (
      <React.Fragment>
        <div className="Welcome">
          {this.state.errorMain && <MainErrorBoundaryParent error={this.state.errorMain}></MainErrorBoundaryParent>}
          <>
            {showWelcome === false ? (
              welcomeOverlay && (
                <Start
                  overlay={welcomeOverlay}
                  title={'Setting Up your instance'}
                  instance={instance}
                  instanceState={instanceState}
                  onStart={() => this.setState({ showWelcome: true })}
                  error={this.state.error}
                  persisted={this.props.persisted}
                  onResolve={this.resolveOrgCreation}
                  showCountryCodeSelector={this.state.showCountryCodeSelector}
                  selectedCountryCode={this.state.selectedCountryCode}
                  onCountryCodeChange={this.handleCountryCodeChange}
                  countryCodeError={this.state.countryCodeError}
                  showPlanSelector={this.state.showPlanSelector}
                  selectedPlan={this.state.selectedPlan}
                  onPlanChange={this.handlePlanChange}
                  planError={this.state.planError}
                />
              )
            ) :

              <CreateProjectPanel
                process_flow={this.state.process_flow}
                setFlow={value => this.setState({ process_flow: value })}
                theme={this.props.theme}
                cancelProjectCreation={this.props.cancelProjectCreation}
                error={this.state.error}
                onResolve={() => this.setState({ project_error: false })}
                showButtons={showButtons}
                sampleProjects={sampleProjects}
                project_error={this.state.project_error}
                createRecord={value => this.createNewSpace(value)}
                sampleProjectJson={this.state.sampleProjectJson}
                tabView={this.props.tabView}
                flowGroups={this.props.masterGroupMapper && this.props.masterGroupMapper.groups ? this.props.masterGroupMapper.groups : {}}
                navigateTo={this.navigateTo}
                myProfile={this.props.myProfile}
                isSubscriptionCheck={this.props.isSubscriptionCheck}
                buyCourse={this.buyCourse}
                isLoadingUPlan={this.state.isLoadingUPlan}
                dispatch={this.props.dispatch}
                getAvailableUserRoles={this.props.getAvailableUserRoles}
                fetchAllgroups={this.props.fetchAllgroups}
                uPCreation={this.state.uPCreation}
                projectCreated={this.state.projectCreated}
                formDialogue={this.state.formDialogue}
                groupLoading={this.state.groupLoading}
                closes={() => this.setState({ uPCreation: false })}
                myUserAccountInfo={this.props.myUserAccountInfo}
                createProject={this.createP}
                addProjectToGroup={this.aPTGroup}
                inviteUsertoProject={this.iUTProject}
                wGroupCreated={this.state.wGroupCreated}
                isAddedDone={this.state.isAddedDone}
                isFlowActive={this.props.isFlowActive}
                RgroupId={this.getRouterFlowGroupId()}
                FlowTypeKey={this.getRouterFlowTypeId()}
                showBuyCourse={this.state.showBuyCourse}
                showBuyGroupInfo={this.state.showBuyGroupInfo}
                hideShowBuyCourse={() => this.setState({ showBuyCourse: false })}
                checkIsAddIntrestedAddons={this.checkIsAddIntrestedAddons}
                refreshGroups={this.refreshGroups}
                projectCreationError={this.state.projectCreationError}
                updateProjectCreationError={this.updateProjectCreationError}
                checkToProject={this.handleChange}
              />
            }

            {overlay && (
              <Overlay
                onResolve={() => {
                  this.setState({ error: null, overlay: null })
                }}
                error={this.state.error}
                tipMessage="Goback & try to select other sample project"
                overlay={overlay}
                status={status}
                instanceState={instanceState}
              />
            )}
          </>
        </div>
      </React.Fragment>
    )
  }
}

Welcome.propTypes = {
  api: PropTypes.object,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  masterGroupMapper: state.masterGroupMapper,
  api: state.api,
  apiError: state.apiError,
  myProfile: state.myProfile,
  myHelpLinks: state.myHelpLinks,
  datoinServices: state.datoinServices,
  bgStatus: state.bgStatus,
  myApps: state.myApps,
  myTemplates: state.myTemplates,
  myReccTemplates: state.myReccTemplates,
  checkUberDeployment: state.checkUberDeployment,
  theme: state.theme,
  myUserAccountInfo: state.myUserAccountInfo,
  isSubscriptionCheck: state.isSubscriptionCheck,
  getAvailableUserRoles: state.getAvailableUserRoles,
  fetchAllgroups: state.fetchAllgroups,
  projectFlowInfoKey: state.emlyFrameWork.projectFlowInfoKey,
  persisted: state.userProfilePersisted,
  projects: state.myProjects,
  learnPracticeFlows: state.learnPracticeFlows,
  buildPracticeFlows: state.buildPracticeFlows,
  flowProcessFlows: state.flowProcessFlows
})

export default withRouter(connect(mapStateToProps)(Welcome))
